import Button from '@mui/material/Button';
import LocalizedLink from '@/components/LocalizedLink';
import RequestQuoteButton from '@/components/RequestQuoteButton';
import FeatureAddToCartCta from '@/features/FeatureAddToCartCta';
import { ROUTES } from '@/constants/application-urls';
import ProductListingDictionary from '@/types/dictionaries/ProductListing';
import { ProductSearchResult } from '@/types/gearApi/Product';
import { getRequestQuoteUrl } from '@/utils/helpers/url';

export interface ProductCardActionButtonProps {
	priceLabel?: string;
	product: ProductSearchResult;
	productDetailsUrl: string;
	requestQuoteUrl: string | null;
	contactUsUrl: string;
	sharedCartId: string | null;
	dict: ProductListingDictionary;
}

export default function ProductCardActionButton({
	priceLabel,
	product,
	productDetailsUrl,
	requestQuoteUrl,
	contactUsUrl,
	sharedCartId,
	dict,
}: ProductCardActionButtonProps) {
	const { name, sku, price, defaultUnitOfMeasure, hasMultipleVariants, isQuoteOnly } = product;
	const baseUrl = requestQuoteUrl ?? contactUsUrl;
	const finalUrl = getRequestQuoteUrl(baseUrl, sku, name);

	if (hasMultipleVariants) {
		return (
			<Button
				variant="contained"
				sx={{ width: '100%' }}
				component={LocalizedLink}
				href={productDetailsUrl}
				prefetch={false}
				data-testid="product-card-choose-variant-button"
			>
				{dict.attributeLabels.chooseModel}
			</Button>
		);
	}

	if (isQuoteOnly) {
		return <RequestQuoteButton buttonText={dict.attributeLabels.requestQuote} url={finalUrl} />;
	}

	if (priceLabel) {
		return (
			<FeatureAddToCartCta
				name={name}
				price={price}
				sku={sku}
				unitOfMeasure={defaultUnitOfMeasure}
				fullWidth={true}
				toastLinkUrl={ROUTES.CART}
				sharedCartId={sharedCartId}
				dict={dict}
			/>
		);
	}

	return null;
}
